export enum OrderStatusEnum {
    ALL = -1,
    INCOMPLETE = 0,
    ORDER_SUBMITTED,
    RECEIVED,
    IN_PROGRESS,
    PARTIALLY_COMPLETED,
    COMPLETED,
    ACTION_REQUIRED, //not used anymore
    CANCELED,
    CANCELED_FROM_LIMS,
}
